import api from "../../../api/clinique/_patients";

export default {
    getPatientInsuranceInfo(patient_id) {
        return new Promise((resolve, reject) => {
            api.getPatientInsuranceInfo(patient_id).then(
                response => {
                    resolve(response);
                }, error => {
                    reject(error);
                }
            )
        })
    },

    getPatients() {
        return new Promise((resolve, reject) => {
            api.getPatients().then((response) => {
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    getListeAllPatient(with_consultation=false) {
        return new Promise((resolve, reject) => {
            api.getListeAllPatient(with_consultation).then((response) => {
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    /**
     * Statistiques DMP
     * @returns 
     */
    getStatsDMP(data) {
        return new Promise((resolve, reject) => {
            api.getStatsDMP(data).then((response) => {
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },
}